<template>
  <div
    v-if="navigation.length"
    class="hidden md:flex xl:hidden items-center"
    v-click-outside="closeMenu"
  >
    <button
      class="flex p-4 rounded-6 hover:bg-gray-50"
      :class="{ 'bg-gray-50': isOpen }"
      @click="toggleMenu"
      @keydown.esc="closeMenu"
      :aria-expanded="isOpen"
    >
      <BurgerToggleIcon :is-open="isOpen" />
    </button>
    <Transition
      enter-active-class="transition duration-300"
      leave-active-class="transition duration-300"
      enter-from-class="translate-x-1/2 opacity-0"
      leave-to-class="translate-x-1/2 opacity-0"
    >
      <nav v-if="isOpen" class="absolute w-1/2 top-20 right-0 mt-2">
        <ul class="list-none bg-gray-50 shadow-2 w-full min-h-screen">
          <MenuContent
            v-for="item in navigation"
            :key="item.id"
            :id="item.id"
            :link="item.link"
            :highlights="item.highlights"
            :items="item.items"
            :sub-label-mobile="item.subLabelMobile"
          />
        </ul>
      </nav>
    </Transition>
  </div>
</template>

<script lang="ts" setup>
import type { GQLNavigationItem } from './generated/page-header'
import { ClickOutside as vClickOutside } from '@core/directives/click-outside'
import BurgerToggleIcon from './burger-toggle-icon.vue'
import { NavigationMenuOpen } from '@core/analytics/core-events/navigation'
import MenuContent from './menu-content.vue'

defineProps<{ navigation: GQLNavigationItem[] }>()

const { $track } = useNuxtApp()

const isOpen = ref(false)

async function toggleMenu() {
  isOpen.value = !isOpen.value
  if (isOpen.value) {
    await $track(NavigationMenuOpen('Menu'))
  }
}

function closeMenu() {
  isOpen.value = false
}
</script>
